export default {
  EmployeeList: () => import('@/views/employee/listPage/EmployeeList'),
}